import { FleetTireRow } from "services/api/fleet/tires/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const TIRE_TYPE_BACKGROUND = (code: string) => {
  switch (code) {
    case "W":
      return (
        <div className="relative w-3 h-3 rounded-full overflow-hidden">
          <div className="absolute top-0 left-0 w-1/2 h-full bg-blue-500"></div>
          <div className="absolute top-0 right-0 w-1/2 h-full bg-blue-500"></div>
        </div>
      );
    case "S":
      return (
        <div className="relative w-3 h-3 rounded-full overflow-hidden">
          <div className="absolute top-0 left-0 w-1/2 h-full bg-yellow-500"></div>
          <div className="absolute top-0 right-0 w-1/2 h-full bg-yellow-500"></div>
        </div>
      );
    case "U":
      return (
        <div className="relative w-3 h-3 rounded-full overflow-hidden">
          <div className="absolute top-0 left-0 w-1/2 h-full bg-blue-500"></div>
          <div className="absolute top-0 right-0 w-1/2 h-full bg-yellow-500"></div>
        </div>
      );
    default:
      return "";
  }
};

// export const TIRE_SEARCH_COLUMNS = (
//   t: (key: string) => string
// ): Column[] => [
//   {
//     title: "",
//     field: "image",
//     type: ColumnTypes.custom,
//     render: (row: FleetTireRow) => {
//       return (
//         <div className="-mt-3 pt-4 -mb-4 pb-4 ml-1 max-w-[50px]">
//           <div className="w-10 h-10 rounded-full bg-gray-200 block relative">
//             <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
//               {TIRE_TYPE_BACKGROUND(row.tireType.code)}
//             </span>
//           </div>
//         </div>
//       );
//     },
//   },
//   {
//     title: "admin.fleet.tire.search.name",
//     field: "",
//     type: ColumnTypes.custom,
//     render: (row: FleetTireRow) => {
//       return (
//         <div className="flex items-center gap-1">
//           <>
//             <div className="flex items-center">
//               {Array.from({ length: row.tireCount ?? 0 }).map((_, index) => (
//                 <>
//                   <ReactSVG
//                     src={"/media/icons/tire.svg"}
//                     className="w-3 stroke-[#667085]"
//                   />
//                 </>
//               ))}
//             </div>
//             <div>{`Set od ${row.tireCount} gume`}</div>
//           </>
//         </div>
//       );
//     },
//   },
//   {
//     title: "admin.fleet.tire.search.dimension",
//     field: "",
//     type: ColumnTypes.custom,
//     render: (row: FleetTireRow) => {
//       return (
//         <div>
//           {row.dimension.map((item, index) => (
//             <div key={index}>{item}</div>
//           ))}
//         </div>
//       );
//     },
//   },
//   {
//     title: "admin.fleet.tire.search.type",
//     field: "",
//     type: ColumnTypes.custom,
//     render: (row: FleetTireRow) => {
//       return <div>{row.tireType?.name}</div>;
//     },
//   },
//   {
//     title: "admin.fleet.tire.search.location",
//     field: "",
//     type: ColumnTypes.custom,
//     render: (row: FleetTireRow) => {
//       return <div>{row.location}</div>;
//     },
//   },
// ];

export const TIRE_SEARCH_COLUMNS = (t: (key: string) => string): Column[] => [
  {
    title: "",
    field: "",
    type: ColumnTypes.custom,
    render: (row: FleetTireRow) => {
      return <div></div>;
    },
  },
  {
    title: "",
    field: "",
    type: ColumnTypes.custom,
    render: (row: FleetTireRow) => {
      return <div></div>;
    },
  },
  {
    title: "admin.fleet.tire.search.name",
    field: "",
    type: ColumnTypes.custom,
    render: (row: FleetTireRow) => {
      return <div>{row.name}</div>;
    },
  },

  {
    title: "admin.fleet.tire.search.manufacturer",
    field: "",
    type: ColumnTypes.custom,
    render: (row: FleetTireRow) => {
      return <div>{row.tireManufacturer?.name}</div>;
    },
  },
  {
    title: "admin.fleet.tire.search.dimension",
    field: "",
    type: ColumnTypes.custom,
    render: (row: FleetTireRow) => {
      return (
        <div>
          {row.width}/{row.height}/{row.radius}
        </div>
      );
    },
  },
  {
    title: "admin.fleet.tire.search.type",
    field: "",
    type: ColumnTypes.custom,
    render: (row: FleetTireRow) => {
      return <div>{row.tireType?.name}</div>;
    },
  },
  {
    title: "admin.fleet.tire.search.dot",
    field: "",
    type: ColumnTypes.custom,
    render: (row: FleetTireRow) => {
      return <div>{row.dot}</div>;
    },
  },
  {
    title: "admin.fleet.tire.search.profiledepth",
    field: "",
    type: ColumnTypes.custom,
    render: (row: FleetTireRow) => {
      return <div>{row.profileDepth}</div>;
    },
  },
];
